// Others
import axiosClient from './axiosClient';
import { urlApiNotification } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  IListNotificationResponse,
  INotification,
  IReadNotificationRes,
} from '~/utils/interface/notification';

const notificationApi = {
  getListNotification(params: IQueryParamBase) {
    const url = urlApiNotification.getListNotification;
    return axiosClient.get<IBaseResponse<IListNotificationResponse<INotification[]>>>(url, { params });
  },

  readNotification(notificationId: string) {
    const url = urlApiNotification.readNotification(notificationId);
    return axiosClient.put<IBaseResponse<IReadNotificationRes>>(url);
  },
};

export default notificationApi;
